<template>
  <base-layout-auditing>
    <template v-slot:top-middle>
      <div class="top-title">
        <div class="title-wrapper">
            <div class="title">{{ isAuditing ? '作品审核中，请稍候' : '作品已上传，专家初选评审中' }}</div>
        </div>
        <div class="article-info">
          <div class="article-info-title">
            <div>
              <span>{{articleInfo}}</span>
              <span @click="onViewArticle" v-if="activityInfo.process_status >= 2">查看文章 ></span>
            </div>
            <p class="article-name">{{personalArtical.title}}</p>
          </div>
          <!--  -->
          <div class="rank-wrapper" v-if="isAuditPass && (+personalArtical.star > 0 || +personalArtical.thumb > 0)">
            <div class="star" v-if="+personalArtical.star > 0">
              <span>文章星级别：</span>
              <span class="icon"></span>
              <span class="join">x</span>
              <span>{{ personalArtical.star }}
              </span>
            </div>
            <div class="rank" v-if="+personalArtical.thumb > 0">
              <span>人气值：</span>
              <span class="icon"></span>
              <span>{{ personalArtical.thumb}}</span>
            </div>
          </div>
        </div>
      </div>
      <Popularity :activityInfo="activityInfo" :personalArtical="personalArtical" v-if="isAuditPass"/>
    </template>
    <Periods :period="activityInfo.period" :activityStatus="activityInfo.activity_status"/>
    <template v-slot:footer>
      <CommonProcess/>
    </template>
  </base-layout-auditing>
</template>
<script>
import BaseLayoutAuditing from '../../common/baseLayoutAuditing'
import Periods from '../../common/periods'
import CommonProcess from '../../common/commonProcess'
import Popularity from './popularity'

export default {
  name: 'notRegistered',
  components: {
    BaseLayoutAuditing,
    Periods,
    CommonProcess,
    Popularity
  },
  props: {
    isAuditing: {
      type: Boolean,
      required: true
    },
    isAuditPass: {
      type: Boolean,
      required: true
    },
    activityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    topicInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    personalArtical: {
      type: Object,
      default() {
        return {}
      }
    },
    cityInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    btnInfo() {
      const { apply_status, submit_status, jumpUrl } = this.activityInfo
      return {
        apply_status,
        submit_status,
        jumpUrl
      }
    },
    articleInfo() {
      return `${this.topicInfo.group_name || ''}第${this.personalArtical.period_id || ''}期（${this.personalArtical.province || ''}）`
    }
  },
  methods: {
    onViewArticle() {
      const articleId = this.personalArtical.artical_id
      this.$router.push({
        name: 'articleDetail',
        query: {
          articleId
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  .top-title {
    margin-top: -2px;
    text-align: center;

    .title {
      margin-bottom: 10px;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 18px;
      text-align: center;
      color: #666;
    }

    .sub-title {
      display: inline-block;
      margin-bottom: 10px;
      font-size: 11px;
      background: linear-gradient(181deg, #fff 0%, #fff5ec 100%);
      border: 1px solid #fff;
      border-radius: 16px;
    }

    .article-info {
      width: 83%;
      margin: 0 auto;
      // background: linear-gradient(181deg, #FFFFFF 0%, #FFF5EC 100%);
      background: #fff;
      border: 1px solid #fff;

      &-title {
        margin: 11px 10px;

        > div {
          display: flex;
          justify-content: space-between;

          > span:first-child {
            height: 16px;
            font-size: 12px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 16px;
            color: #a4715b;
          }

          > span:nth-child(2) {
            height: 15px;
            font-size: 11px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 15px;
            color: #ca0808;
          }
        }
      }

      .article-name {
        height: 24px;
        margin: 6px 0 16px;
        overflow: hidden;
        font-size: 17px;
        font-weight: 600;
        font-family: PingFangSC-Semibold, PingFang SC;
        line-height: 24px;
        text-align: left;
        white-space: nowrap;
        // text-indent: -0.5em;
        color: #a4715b;
        text-overflow: ellipsis;
      }

      .rank-wrapper {
        display: flex;
        padding: 9px 10px;
        text-align: left;
        border-top: 1px solid #e1b38f;

        > div {
          flex: 1;
          height: 18px;
          font-size: 13px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 18px;
          color: #a4715b;

          &:first-child {
            text-align: left !important;
          }
        }

        .star {
          text-align: left;

          .join {
            margin: 0 4px;
          }

          .icon {
            display: inline-block;
            width: 14px;
            height: 14px;
            vertical-align: -3px;
            background-image: url('../../../../../assets/apply/star_icon.png');
            background-size: contain;
          }
        }

        .rank {
          text-align: right;

          .icon {
            display: inline-block;
            width: 12px;
            height: 10px;
            margin-right: 4px;
            background-image: url('../../../../../assets/apply/crown_icon.png');
            background-size: contain;
          }
        }
      }
    }
  }

  .dividing-line {
    position: relative;
    width: 89%;
    height: 1px;
    margin: 10px auto 50px;
    text-align: center;
    background: #f2dccd;

    &::before,
    &::after {
      position: absolute;
      top: 0;
      width: 12px;
      height: 12px;
      background: #ca0808;
      border-radius: 50%;
      content: '';
    }

    &::before {
      left: 0;
      transform: translate3d(-55%, -50%, 0);
    }

    &::after {
      right: 0;
      transform: translate3d(55%, -50%, 0);
    }
  }

  .btn-outer-wrapper {
    position: relative;
    display: inline-block;

    .tip {
      position: absolute;
      bottom: 120%;
      padding: 5px 10px;
      font-size: 11px;
      font-weight: 400;
      color: #a5725c;
      background: #ffedda;
      border: 1px solid #ffdcdc;
      box-shadow: 0 0 11px 0 rgba(255, 200, 88, 0.5);

      &::before,
      &::after {
        position: absolute;
        right: 5%;
        transform: translateX(-50%);
        content: ' ';
      }

      &::before {
        top: 100%;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 8px solid #ffdcdc;
      }

      &::after {
        top: 95%;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 8px solid #fff3d6;
      }
    }
  }

  .periods-wrapper {
    box-sizing: border-box;
    width: 90%;
    margin: 0 auto;

    ul {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;

      li {
        flex: 1;
      }
    }

    .desc {
      text-align: center;
    }
  }
}
</style>
